import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Row, Col, Button } from "reactstrap";
import { MaterialReactTable } from "material-react-table";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import { MenuItem } from "@mui/material";
import {
  setSuccessMessage,
  setEditSuccessMessage,
  setDeleteSuccessMessage,
} from "../../slices/toastMessage/action";
import moment from "moment";
import { cancelStatus } from "../../slices/Device/DeleteStatus/thunk";
import { getAllDevice } from "../../slices/Device/Devicelist/thunk";
import { deviceColumns } from "./constants/coloumn"
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PAGE_TITLES } from "../Common/constants";
import { handleExportData } from "../Utils/ExportToCsv";
import { useColumnSettings } from "../Utils/useColumnSettings";
import CommonModal from "../Utils/CommonModal";
import { hasPermission } from "../Utils/UtilityFunctions";

function DeviceListings() {
  const [loading, setLoading] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const rawPermissions = useSelector(
    (state) => state.permissions.permissionsMap
  );

  const permissionsMap = new Map(
    rawPermissions.map(([key, value]) => [key, new Set(value)])
  );
  const devicePermission = hasPermission(permissionsMap, "device", "device")
  const viewPermission = hasPermission(permissionsMap, "miscellaneous", "view")

  const showSuccessMessage = useSelector(
    (state) => state.SuccessToast.showSuccessMessage
  );
  const showEditSuccessMessage = useSelector(
    (state) => state.SuccessToast.showEditSuccessMessage
  );

  const showDeleteSuccessMessage = useSelector(
    (state) => state.SuccessToast.showDeleteSuccessMessage
  );

  let dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  const closeModal = () => {
    setModal(!modal);
  };
  const toggleModal = (row) => {
    if (row && row.original) {
      const deviceId = row.original.deviceId;
      setDeviceId(deviceId);
      setModal((prevModal) => !prevModal);
    }
  };

  const device = useSelector((state) => state.device.device);
  const dateFormat = localStorage.getItem("dateFormat") || "DD MMM YYYY";
  const formattedDates = device && Array.isArray(device)
    ? device.map((item) => moment(item.createdAt).format(dateFormat))
    : [];

  const columns = deviceColumns(formattedDates)

  let navigate = useNavigate();

  const {
    settingsModalOpen,
    viewColumns,
    toggleSettingsModal,
    CustomViewModal,
  } = useColumnSettings("Device", columns);

  useEffect(() => {
    if (showSuccessMessage) {
      toast.success(`Device Created Successfully`);
      dispatch(setSuccessMessage(false));
    }

    if (showEditSuccessMessage) {
      toast.success(`Device Updated Successfully`);
      dispatch(setEditSuccessMessage(false));
    }

    if (showDeleteSuccessMessage) {
      toast.success(`Device Status Updated Successfully`);
      dispatch(setDeleteSuccessMessage(false));
    }
  }, [showSuccessMessage, dispatch, showDeleteSuccessMessage]);

  const handleChangeStatus = async () => {
    dispatch(cancelStatus(deviceId, setLoading, navigate));
  };

  const navigateToDevice = () => {
    navigate('/create-device')
  }

  useEffect(() => {
    dispatch(getAllDevice(setLoading));
  }, [dispatch]);

  return (
    <React.Fragment>
      <div id="csms" className="page-content">
        <Container fluid>
          <BreadCrumb title={PAGE_TITLES.DEVICE_LIST} pageTitle={PAGE_TITLES.DEVICE} moduleTitle="Devices" />
          <ToastContainer position="top-center" />
          <Row>
            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
              <div className="d-flex flex-column flex-md-row">
                <h5 className="rv-page-title p-1">
                  {"Device List"}
                </h5>
              </div>
              <div className="d-flex align-items-center">
                {devicePermission && devicePermission?.has("export") &&
                  <Button color="secondary" className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mx-1" onClick={() => { handleExportData(device) }}>
                    <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2 fw-bold"></i>
                    <span className="px-2 ps-3 ms-2 me-1 fw-bold">Export</span>
                  </Button>}
                {devicePermission && devicePermission?.has('create') && <Button color="secondary" className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-md-auto text-nowrap mx-1" onClick={navigateToDevice}>
                  <i className="ri-add-fill label-icon align-middle fs-16 me-1 fw-bold"></i>
                  <span className="ps-2 ms-2 me-1 fw-bold">
                    {"Add Device"}
                  </span>
                </Button>}
                {viewPermission && viewPermission?.has("view") &&
                  <div
                    color="secondary"
                    className="btn-icon cursor-img"
                    onClick={toggleSettingsModal}
                  >
                    <i className="ri-settings-2-line fs-4"></i>
                  </div>}
              </div>
            </div>
            <Col lg={12}>
              <div className="listingjs-table " id="customerList">
                <div className="mb-3 mt-1 mx-1 border table-responsive">
                  {loading && <Loader />}
                  {device ? (
                    <MaterialReactTable
                      muiTableHeadCellProps={{
                        sx: {
                          fontFamily: "Inter,sans-serif",
                        },
                      }}
                      muiTableBodyCellProps={{
                        sx: {
                          fontFamily: "Inter,sans-serif",
                        },
                      }}
                      columns={columns}
                      data={device}
                      enableColumnOrdering={false}
                      enableColumnDragging={false}
                      enableDensityToggle={false}
                      enableColumnActions={true}
                      enableTopToolbar={false}
                      enableRowActions
                      initialState={{
                        columnVisibility: {
                          "mrt-row-expand": false,
                        },
                      }}
                      displayColumnDefOptions={{
                        "mrt-row-actions": {
                          header: "",
                          enableHiding: true,
                        },
                      }}

                      renderRowActionMenuItems={({ closeMenu, row }) => {
                        if (row.original.status === 'Terminated') {
                          return [
                            devicePermission && devicePermission?.has('update') ? <MenuItem
                              className="row-options"
                              key="edit"
                              onClick={() => {
                                navigate(`/update-device/${row.original.deviceId}`);
                              }}
                            >
                              <i className="ri-edit-box-line me-2" />
                              Edit
                            </MenuItem> : null,
                          ];
                        } else {
                          return [
                            devicePermission && devicePermission?.has('view') ? <MenuItem
                              className="row-options"
                              key="view"
                              onClick={() => {
                                navigate(`/view-device/${row.original.deviceId}`);
                              }}
                            >
                              <i className="ri-eye-line me-2" />
                              View
                            </MenuItem> : null,
                            devicePermission && devicePermission?.has('update') ? <MenuItem
                              className="row-options"
                              key="edit"
                              onClick={() => {
                                navigate(`/update-device/${row.original.deviceId}`);
                              }}
                            >
                              <i className="ri-edit-box-line  me-2" />
                              Edit
                            </MenuItem> : null,
                            devicePermission && devicePermission?.has('delete') ? <MenuItem
                              key="preview"
                              onClick={() => {
                                closeMenu();
                                toggleModal(row);
                                closeModal();
                              }}
                            >
                              {" "}
                              <i className="ri ri-delete-bin-5-line me-2" />{" "}
                              Delete
                            </MenuItem> : null,
                          ];
                        }
                      }}
                    />
                  ) : null}
                </div>

              </div>
            </Col>
            {CustomViewModal()}
          </Row>
        </Container>
        <CommonModal
          open={modal}
          toggle={closeModal}
          buttonText={"Yes, Delete It"}
          modalHeader={"Delete Device"}
          messageForPopUp={`Are you sure you want to delete his device "${deviceId}"?`}
          modalAction={() => {
            handleChangeStatus(deviceId), closeModal()
          }}
        />
      </div>
      {loading && <Loader />}
    </React.Fragment>
  );
}
export default DeviceListings;